import React, {Component} from 'react';
import styled from 'styled-components';
import {mixins} from "../../mixins";
import {Link} from "react-router-dom";

class Button extends Component {
    render() {
        if (!this.props.to) {
            return (
                <button disabled={this.props.disabled} type={this.props.type}
                        onClick={() => typeof (this.props.onClick) === "function" ? this.props.onClick() : ''}
                        className={`${this.props.className} ${this.props.type === 'icon' ? 'button-icon' : ''}
                        ${this.props.wireframe ? 'wireframe' : ''}
                        ${this.props.secondary ? 'secondary' : ''}
                        ${this.props.menu ? 'menu' : ''}
                        `}>
                    {this.props.type === 'icon' ? <i className={'icon-' + this.props.icon}/> : ''}
                    <span>{this.props.label}</span>
                </button>
            )
        } else {
            return (
                <Link disabled={this.props.disabled} to={this.props.to}
                      className={`${this.props.className} ${this.props.type === 'icon' ? 'button-icon' : ''}
                      ${this.props.wireframe ? 'wireframe' : ''}
                      ${this.props.secondary ? 'secondary' : ''}
                      ${this.props.menu ? 'menu' : ''}
                      `}>
                    {this.props.type === 'icon' ? <i className={'icon-' + this.props.icon}/> : ''}
                    <span>{this.props.label}</span>
                </Link>
            )
        }

    }
}

export default styled(Button)`
  cursor: pointer;
  height: ${p => p.theme.sInput}px;
  width: ${p => p.fullWidth ? '100%' : 'auto'};
  border-width: 1px;
  border-style: solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${p => p.fixedMin ? '220px' : ''};
  padding-left: 15px;
  padding-right: 15px;
  text-transform: uppercase;
  font-weight: 900;
  outline: none !important;
  ${mixins.ease()};
  background-color: ${p => p.theme.cTheme};
  border-color: ${p => p.theme.cTheme};
  color: ${p => p.theme.cWhite};
  &.wireframe{
    background-color: transparent;
    color: ${p => p.theme.cTheme};
  }
  &.secondary{
    background-color: ${p => p.theme.cAccent};
    border-color: ${p => p.theme.cAccent};
    color: ${p => p.theme.cWhite};
    &.wireframe{
      background-color: transparent;
      color: ${p => p.theme.cAccent};
    }
  }
  &.menu{
    background-color: transparent;
    border-color: ${p => p.theme.cWhite};
    color: ${p => p.theme.cWhite};
  }
  &:hover, &:focus{
    text-decoration: none;
    color: ${p => p.theme.cWhite};
    background-color: ${p => p.theme.cThemeActive};
    border-color: ${p => p.theme.cThemeActive};
    &.secondary{
      background-color: ${p => p.theme.cAccentActive};
      border-color: ${p => p.theme.cAccentActive};
    }
  }
  &.button-icon{
    background: none;
    border: none;
    color: ${p => p.theme.cText};
    font-weight: normal;
    text-transform: none;
    padding-left: 0;
    i{
      margin-right: 10px;
      font-size: ${p => p.theme.sIcon}px;
    }
    &:hover, &:focus{
      span{
        text-decoration: underline;
      }
    }
  }
  &[disabled], &:disabled{
    cursor: not-allowed;
    background-color: ${p => p.theme.cMicrocopyText};
    border-color: ${p => p.theme.cMicrocopyText};
  }
`;